var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUploadFileIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 49,
    viewBox: "0 0 48 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 1,
    width: 47,
    height: 47,
    rx: 23.5,
    fill: "#28ABA1",
    stroke: "#B3FFF4"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23 32.6663H25V28.6663H29V26.6663H25V22.6663H23V26.6663H19V28.6663H23V32.6663ZM16.4 37.6663C15.7333 37.6663 15.1667 37.433 14.7 36.9663C14.2333 36.4997 14 35.933 14 35.2663V14.733C14 14.0663 14.2333 13.4997 14.7 13.033C15.1667 12.5663 15.7333 12.333 16.4 12.333H27L34 19.333V35.2663C34 35.933 33.7667 36.4997 33.3 36.9663C32.8333 37.433 32.2667 37.6663 31.6 37.6663H16.4ZM26 20.333V14.333H16.4C16.3111 14.333 16.2222 14.3775 16.1333 14.4663C16.0444 14.5552 16 14.6441 16 14.733V35.2663C16 35.3552 16.0444 35.4441 16.1333 35.533C16.2222 35.6219 16.3111 35.6663 16.4 35.6663H31.6C31.6889 35.6663 31.7778 35.6219 31.8667 35.533C31.9556 35.4441 32 35.3552 32 35.2663V20.333H26Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadFileIcon);
export default __webpack_public_path__ + "static/media/upload-file-icon.0e58ffac.svg";
export { ForwardRef as ReactComponent };